// chakra imports
import { Icon, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { MdDoorbell, MdNotifications } from "react-icons/md";
import React from "react";
const { DateTime } = require("luxon");

export function ItemContent(props) {
  const formatTime = (timestamp) => {
    const myDateTime = DateTime.fromISO(timestamp);
    return myDateTime.toLocaleString(DateTime.DATETIME_MED);
  };

  const textColor = useColorModeValue("navy.700", "white");
  return (
    <>
      <Flex
        justify='center'
        align='center'
        borderRadius='16px'
        minH={{ base: "30px", md: "35px" }}
        h={{ base: "30px", md: "35px" }}
        minW={{ base: "30px", md: "35px" }}
        w={{ base: "30px", md: "35px" }}
        me='14px'
        bg='brand.500'>
        <Icon as={MdNotifications} color='white' w={8} h={8} />
      </Flex>
      <Flex flexDirection='column'>
        <Text
          mb='5px'
          fontWeight='bold'
          color={textColor}
          fontSize={{ base: "md", md: "md" }}>
          {props.info}
        </Text>
        <Flex alignItems='center'>
          <Text
            fontSize={{ base: "sm", md: "sm" }}
            lineHeight='100%'
            color={textColor}>
            {formatTime(props.date)}
          </Text>
        </Flex>
      </Flex>
    </>
  );
}
